import { type TableColumnConfig, TextEllipsisCellComponent } from '@pct-ng/feature-table-material';

export function createCreatedByNameColumn<T>(
  i18nPrefix: string,
  sortable = false,
): TableColumnConfig<T> {
  return {
    id: 'createdByName',
    field: 'createdByName' as keyof T,
    label: `${i18nPrefix}CREATED_BY_NAME`,
    cellContent: TextEllipsisCellComponent,
    sortable,
  };
}
